import * as React from "react"
import { useState } from "react"
import { AppTooltip } from 'app/@components'
import ConfirmModal from "./ConfirmModal"

export default function MainHotelPinIcon({ isActive, hotelName, onConfirm }) {
    const [showConfirmModal, setShowConfirmModal] = useState(false)

    const handleClick = () => {
        if (!isActive) {
            setShowConfirmModal(true)
        }
    }

    const handleConfirm = () => {
        setShowConfirmModal(false)
        onConfirm()
    }

    const className = isActive
        ? 'main-hotel-pin-icon main-hotel-pin-icon--active'
        : 'main-hotel-pin-icon main-hotel-pin-icon--inactive'

    return <>
        <AppTooltip
            title={isActive ? 'Main hotel (reference for calculations)' : 'Click to set as main hotel'}
            placement="right"
        >
            <div className={className} onClick={handleClick}>
                M
                {isActive && <div className="main-hotel-pin-icon__pin" />}
            </div>
        </AppTooltip>
        <ConfirmModal
            isOpen={showConfirmModal}
            onClose={() => setShowConfirmModal(false)}
            onConfirm={handleConfirm}
            hotelName={hotelName}
        />
    </>
}
